var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SessionExpiryToast',{attrs:{"visible":_vm.showWarningToast,"total-warning-time":_vm.timeRemainingUntilExpiry},on:{"extend-session":_vm.handleExtendSession,"dismiss":_vm.hideWarningToast,"timeout":_vm.handleToastTimeout}}),_c('SessionExpiredModal',{attrs:{"visible":_vm.showExpiredModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }